import S from 'constants/string.const';

const asInput = (value) => {
  if (value === null || void 1 === value) return S.empty;
  if (value === Infinity || value === -Infinity || Number.isNaN(value)) return S.empty;

  return String(value);
};

// noinspection JSUnusedGlobalSymbols
export default asInput;
